<template>
  <div>
    <demandeEntete
      :demandeur="demandeur"
      :typeDemande="typeDemande"
      :codeTypeDemande="codeTypeDemande"
      :dateCreation="dateCreation"
      :commentaire="commentaire"
      :complements="complements"
      :motifRefus="motifRefus"
    />

    <v-card flat v-if="modeCreationExNihilo">
      <v-list-item>
        <v-list-item-content two-line class="pt-0">
          <v-list-item-title class="headline"
            >Personnes physiques existantes</v-list-item-title
          >
          <v-list-item-subtitle
            >Veuillez sélectionner la personne physique de
            rattachement</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <v-card-text class="pt-0">
        <v-radio-group
          v-model="idHomonyme"
          dense
          :disabled="this.control.terminer"
        >
          <v-simple-table dense>
            <thead>
              <tr>
                <td colspan="3">
                  <v-radio
                    label="Créer une nouvelle personne physique"
                    :value="-1"
                  />
                </td>
              </tr>
              <tr>
                <th scope="col">N°</th>
                <th scope="col">Nom</th>
                <th scope="col">Prénom</th>
                <th scope="col">Mail</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(h, i) in homonymes"
                :key="`homonyme${i}`"
                @click="idHomonyme = h.id"
              >
                <td><v-radio :label="`${h.id}`" :value="h.id" /></td>
                <td>{{ h.nom }}</td>
                <td>{{ h.prenoms }}</td>
                <td>{{ h.mailPrincipal }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-radio-group>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          v-if="this.idDemandePersonneMorale != null"
          text
          @click="lienDemande()"
          class="accent"
        >
          Lié à la demande de création de personne morale
          {{ this.idDemandePersonneMorale }}
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>

    <viewPersonnePhysique
      ref="view"
      :propositionAdresse="adresseMobile != null ? true : false"
      :adressePropose="adresseMobile"
      titreProposition="l'adresse de la carte"
      :idContact="0"
      :carteVisite="carteVisite"
      :afficherCarteVisitePossible="true"
      :CreerPersonneMoralePossible="true"
      :donneesConfidentiellesVisibles="donneesConfidentiellesVisibles"
      :enums="enums"
      :form="form"
      :control="control"
      :enModeCreation="enModeCreation"
      :enModeReactivation="enModeReactivation"
      :analyseDiff="analyseDiff"
      @annulerSuppression="annulerSuppression($event)"
      :pphReadonly="control.enDemandeAjoutContact"
      @valideNouveauContact="valideNouveauContact"
      @supprimerContact="supprimerContact"
      @idContact="setIdContact"
    >
      <entiteActionsMobile
        :type="'contact'"
        :id="idContactSelectionne"
        :demandeModication="demandeContactModificationPossible"
        :demandeSuppression="demandeContactModificationPossible"
        :enModeReactivation="demandeActivationContactPossible"
      >
        <v-btn
          text
          v-if="demandeActivationContactPossible"
          @click="reactiverContact"
        >
          Réactiver
        </v-btn>
      </entiteActionsMobile>
      <template
        v-if="
          this.control.enDemandeModification ||
            this.control.enDemandeCreation ||
            this.control.enDemandeSuppression
        "
        #zoneBasse
      >
        <v-list-item>
          <v-list-item-content two-line class="pt-0">
            <v-list-item-title class="headline"
              >Raison de la demande</v-list-item-title
            >
            <v-list-item-subtitle
              >Veuillez saisir les raisons motivant cette
              demande</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-textarea
                filled
                label="Commentaire"
                v-model="commentaire"
                :rules="[serveurRule('commentaire')]"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </template>
    </viewPersonnePhysique>
    <entiteModificationModal />
    <demandeAction />
  </div>
</template>
<script>
import moment from 'moment';
import ViewPersonnePhysique from '@/view/personnephysique/ViewPersonnePhysique';
import EditeurDemande from '@/plugins/mixins/EditeurDemande';
import { routeEnter } from '@/utils/entite';
import toasted from '@/utils/toasted';
import DemandeEntete from '@/components/workflow/DemandeEntete';
import DemandeAction from '@/components/workflow/DemandeAction';
import { getInternational } from '@/components/telephone/telephoneUtil';
import { nettoyageTelephone } from '@/view/personnephysique/personnephysiqueUtils';

export default {
  components: {
    viewPersonnePhysique: ViewPersonnePhysique,
    demandeEntete: DemandeEntete,
    demandeAction: DemandeAction,
  },
  mixins: [EditeurDemande],
  props: {
    enModeCreation: {
      type: Boolean,
      default: false,
    },
    enDemandeCreation: {
      type: Boolean,
      default: false,
    },
    enModeReactivation: {
      type: Boolean,
      default: false,
    },
    deleted: {
      type: Boolean,
      default: false,
    },
  },
  beforeRouteEnter: routeEnter(withId => {
    withId(
      id => `workflow/demande/${id}`,
      (vm, body) => vm.initForm(body),
    );
  }),
  data() {
    return {
      enums: {
        civilites: [],
        fonctions: [],
        typesContact: [],
        typesAccesAgil: [],
        typesAcces: [],
        typesLait: [],
        personnesMorales: [],
      },
      motifRefus: null,
      donneesConfidentiellesVisibles: false,
      homonymes: null,
      idHomonyme: -1,
      idContactSelectionne: null,
      idDemandePersonneMorale: null,
      carteVisite: null,
      adresseMobile: null,
      form: {
        id: null,
        nom: null,
        prenoms: null,
        civilite: {
          id: null,
          libelle: null,
        },
        telephone: null,
        confidentialiteTelephone: null,
        smsAccepte: null,
        mailPrincipal: null,
        confidentialiteMail: null,
        contacts: [],
        accesAgil: null,
        acces: null,

        //RGPD
        dateCreation: null,
        chargeCreation: null,
        dateModification: null,
        chargeModification: null,
        demandeurCreation: null,
      },
    };
  },

  computed: {
    pphReadonly() {
      if (this.modeCreationExNihilo) {
        return this.idHomonyme >= 0;
      }

      // s'il n'y a pas d'id de contact et qu'il y a un unique contact c'est une demande de rajoute de contact
      const contacts = this.form.contacts;
      return contacts.length == 1 && !contacts[0].id;
    },

    modeCreationExNihilo() {
      return !!this.homonymes;
    },
    demandeContactModificationPossible() {
      return (
        this.contactSelectionne &&
        this.contactSelectionne.edition === 'DEMANDE' &&
        !this.contactSelectionne.deleted
      );
    },
    demandeAjoutContactPossible() {
      return (
        this.control.readonly &&
        !this.control.enDemandeSuppression &&
        !this.control.enDemandeModification &&
        !this.enModeReactivation &&
        this.control.edition !== 'DIRECT'
      );
    },
    demandeActivationContactPossible() {
      return this.enModeReactivation;
    },
  },

  methods: {
    initForm(data) {
      this.initEditeurDemande(data);

      //injection du droit d'edition
      this.control.edition = 'AUCUN';
      this.control.readonly = this.control.terminer;
      this.homonymes = data.homonymes;
      this.idDemandePersonneMorale = data.idDemandePersonneMorale;
      this.idHomonyme = -1;
      this.carteVisite = data.carteVisite;
      this.adresseMobile = data.adresseMobile;
      const loaded = data.objet;
      this.form.dateCreation = loaded.dateCreation;
      this.form.chargeCreation = loaded.chargeCreation;
      this.form.dateModification = loaded.dateModification;
      this.form.demandeurCreation = loaded.demandeurCreation;
      this.form.chargeModification = loaded.chargeModification;

      // this.form.identifiant = loaded.identifiant;
      this.form.nom = loaded.nom;
      this.form.prenoms = loaded.prenoms;
      this.form.civilite.id = loaded.civilite.id;
      this.form.civilite.libelle = loaded.civilite.libelle;
      this.form.telephone = getInternational(loaded.telephone.trim());
      this.form.accesAgil = [];
      this.form.acces = [];
      //  this.form.confidentialiteTelephone = loaded.confidentialiteTelephone;
      // this.form.smsAccepte = loaded.smsAccepte;
      this.form.mailPrincipal = loaded.mailPrincipal;
      //  this.form.confidentialiteMail = loaded.confidentialiteMail;
      /** this.form.contacts = loaded.contacts.map(c => {
        c.invalid = 0;
        return c;
      });
      this.form.accesAgil = [...loaded.accesAgil];
      this.form.acces = [...loaded.acces];

      this.donneesConfidentiellesVisibles =
        loaded.donneesConfidentiellesVisibles;
      */
      if (data.enums) {
        this.initEnums(data.enums);
      }

      this.__initEdition();
    },
    selectionContact() {
      const contactId = this.$route.params.contact;

      this.contactsVisible.forEach((item, index) => {
        //sélection automatique du contact
        if (item.id === contactId) {
          this.idContact = index;
          this.idContactSelectionne = this.contactsVisible[index].id;
        }
      });
    },
    initEnums(body) {
      const enums = this.enums;
      enums.civilites = body.civilites;
      enums.fonctions = body.fonctions;
      enums.typesContact = body.typesContact;
      enums.typesAccesAgil = body.typesAccesAgil;
      enums.typesLait = body.typesLait;
      enums.typesAcces = body.typesAcces;

      enums.personnesMorales = body.personnesMorales || [];
    },

    getForms() {
      //access aux formulaire à créer
      return this.$refs.view.getForms();
    },
    creationPromiseSauvegarde(id, form) {
      const pph = nettoyageTelephone(form);

      if (this.control.enDemandeModification) {
        pph.contacts = [pph.contacts[this.idContact]];
        pph.commentaire = this.commentaire;
        return this.$api(`workflow/personne-physique/${id}`).post(pph);
      } else if (this.control.enDemandeCreation) {
        if (this.control.enDemandeAjoutContact) {
          //rajout de contact
          const contact = { ...pph.contacts[this.idContact] };
          contact.idDemandePersonneMorale =
            pph.contacts[this.idContact].demandePersonneMorale;
          contact.commentaire = this.commentaire;
          return this.$api(`workflow/personne-physique/${id}/contact`).post(
            contact,
          );
        } else {
          //creation ex-nihilo
          pph.contacts = [pph.contacts[this.idContact]];
          pph.commentaire = this.commentaire;
          pph.idDemandePersonneMorale =
            pph.contacts[this.idContact].demandePersonneMorale;
          return this.$api('workflow/personne-physique').post(pph);
        }
      } else if (this.control.enDemandeSuppression) {
        const contact = { ...pph.contacts[this.idContact] };
        return this.$api(
          `workflow/personne-physique/suppression/${contact.id}`,
        ).post({
          commentaire: this.commentaire,
        });
      } else if (this.control.enCreation) {
        //creation ex-nihilo
        pph.contacts = [pph.contacts[this.idContact]];
        return this.$api('personne-physique').put(pph);
      } else {
        return this.$api(`personne-physique/${id}`).post(pph);
      }
    },
    __valideNouveauContact(personneMorale) {
      const dateLimiteValidite = moment()
        .add(2, 'years')
        .format('YYYY-MM-DD');

      this.idContact = this.form.contacts.length;
      this.form.contacts.push({
        personneMorale: {
          id: personneMorale.id,
          raisonSociale: personneMorale.raisonSociale,
          nomUsuel: personneMorale.nomUsuel,
        },
        demandePersonneMorale: personneMorale.idDemande,
        invalid: 0,
        id: null,
        telPP: false,
        mailPP: false,
        collaborateurMDL: personneMorale.collaborateurMDL || false,
        adresses: [],
        telephones: [],
        typeLait: [],
        dateLimiteValidite,
      });
    },
    valideNouveauContact(personneMorale) {
      const idPM = personneMorale.id;
      if (idPM == null) {
        this.$api('enums/personnephysique/personnemorale/0')
          .get()
          .then(response => {
            const body = response.body;
            this.initEnums(body);
            this.__valideNouveauContact(personneMorale);
            if ('demande' === personneMorale.type) {
              this.control.enDemandeCreation = true;
              this.control.readonly = false;
              this.control.enDemandeAjoutContact = true;
            }
          });
      } else {
        if ('demande' === personneMorale.type) {
          // il faut charger les informations de la personne specifique + les informations de la personne
          this.$api(`enums/personnephysique/personnemorale/${idPM}`)
            .get()
            .then(response => {
              const body = response.body;
              this.initEnums(body);

              this.__initEdition();
              this.__valideNouveauContact(personneMorale);
              this.control.enDemandeCreation = true;
              this.control.readonly = false;
              this.control.enDemandeAjoutContact = true;
              this.getForms().forEach(f => f.resetValidation());
            });
        } else {
          // si les informations de la personne morale n'existent pas, il faut chercher les informations  divisions et contacts de la PM .
          const pmExists = this.enums.personnesMorales.some(p => idPM === p.id);
          if (!pmExists) {
            this.$api(`enums/personnephysique/simple-personnemorale/${idPM}`)
              .get()
              .then(response => {
                const body = response.body;
                this.enums.personnesMorales.push(body);
                this.__valideNouveauContact(personneMorale);
              });
          } else {
            this.__valideNouveauContact(personneMorale);
          }
        }
      }
    },

    lienDemande() {
      this.$router.push({
        name: 'workflow/demande/personnemorale/detail',
        params: {
          id: this.idDemandePersonneMorale,
        },
      });
    },

    validerDemande() {
      const id = this.idDemande;
      const pph = nettoyageTelephone(this.form);

      var data = null;
      var url = null;

      if (this.idDemandePersonneMorale != null) {
        this.control.dialogValider = false;
        toasted.error('demande.status.PMFirst');
        return;
      }
      if (!this.__valider()) {
        this.control.dialogValider = false;
        return;
      }

      if (this.modeCreationExNihilo) {
        //2 urls possibles, soit on utiliser un homonyme (donc on passe juste le contact) soit on creer tout
        if (this.idHomonyme >= 0) {
          url = `workflow/demande/creation/${id}/personne-physique/${this.idHomonyme}/mobile/valider`;
          data = pph.contacts[0];
        } else {
          url = `workflow/demande/creation/${id}/personne-physique/valider`;
          data = pph;
        }
      } else {
        url = `workflow/demande/creation/${id}/contact/valider`;
        data = this.form.contacts[0];
      }

      this.control.validerDemande = true;
      this.$api(url)
        .post(data)
        .then(() => {
          toasted.info('demande.status.valide');
          this.__annuler(false);
          this.$router.push({ name: 'workflow/demande' });
        })
        .catch(errors => {
          this.control.dialogValider = false;
          this.errorsHandler(errors);
        })
        .finally(() => (this.control.validerDemande = false));
    },
    ajouterDemandeContact() {
      this.$refs.view.ajouterContact('demande');
    },
    supprimerContact(index) {
      this.form.contacts.splice(index, 1);
    },
    setIdContact(index) {
      this.idContact = index;
      this.idContactSelectionne = this.form.contacts[index].id;
    },
  },
};
</script>
